import { createReducer, on } from '@ngrx/store';
import { setIntermediaryRelatedAction } from './intermediaryRelated.actions';



export const initialState = false;

export const intermediaryRelatedReducer = createReducer(
  initialState,
  on(setIntermediaryRelatedAction, (state, { intermediaryRelated }) => intermediaryRelated)
);